/**
 * URLクエリパラメータから初期表示用のselectedChoiceIdsを取得
 * 動的な変更はpostMessageで受け取る
 */
export const getDefaultShowChartIds = (): string[] | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  const selectedChoiceIdsParam = urlParams.get("selectedChoiceIds");
  return selectedChoiceIdsParam ? selectedChoiceIdsParam.split(",") : undefined;
};
